import styled from 'styled-components'

export const CityPlansFiltersWrapper = styled.div`
  padding: 29px 0 0 0;

  & > div:nth-child(1) {
    width: 100%;
    max-width: 285px;
    float: left;

    input {
      width: 100%;
      max-width: 285px;
    }
  }

  & > div:not(:nth-child(1)),
  & > a {
    float: right;
  }

  & > div:not(:nth-child(1)) {
    margin-right: 20px;
  }

  & > div:nth-child(2) .form-select {
    width: 146px !important;
  }

  & > div:nth-child(3) .form-select {
    width: 108px !important;
  }
`



// WEBPACK FOOTER //
// ./src/Components/Campaigns/Page/CityPlans/CityPlansFiltersWrapper/index.js